import { format, isValid, parse } from "date-fns";

export function formatTimeAnswerToISOTime(answertime: string) {
    let parsedTime = parse(answertime, "hh:mm a", new Date());
    if (!isValid(parsedTime)) {
        return "";
    }
    return format(parsedTime, "HH:mm");
}

export function formatDateToTimeAnswer(date: Date) {
    return format(date, "hh:mm a");
}

export function format24HTimeToTimeAnswer(isoTime: string) {
    let parsedTime = parse(isoTime, "HH:mm", new Date());
    if (!isValid(parsedTime)) {
        return "";
    }
    return formatDateToTimeAnswer(parsedTime);
}